import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { ASSETS } from "../data/assets";

const navLinks = [
  { hash: "#accueil", label: "Accueil" },
  { hash: "#cours", label: "Cours" },
  { hash: "#mariage", label: "Mariage" },
  { hash: "#a-propos", label: "À propos" },
  { hash: "#videos", label: "Vidéos" },
  { hash: "#avis", label: "Avis" },
  { hash: "#tarifs", label: "Tarifs" },
  { hash: "#assistant", label: "Assistant" },
  { hash: "#contact", label: "Contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const closeMenu = () => setOpen(false);

  // Build link href : on home page, use plain hash so browser scrolls smoothly.
  // On any other page, use absolute /<hash> so it navigates back home then scrolls.
  const buildHref = (hash) => (isHome ? hash : `/${hash}`);

  return (
    <header
      data-testid="site-header"
      style={{ top: "var(--promo-banner-h, 0px)" }}
      className={`fixed left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || !isHome
          ? "bg-[#0E1A2B]/85 backdrop-blur-xl border-b border-[#C9A869]/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 flex items-center justify-between h-20">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 group">
          <img src={ASSETS.logo} alt="Louis-Melchior Danse" className="h-12 w-auto" />
          <span className="hidden md:flex flex-col leading-tight">
            <span className="serif text-lg text-[#F7F3EA] tracking-wider">Louis-Melchior</span>
            <span className="text-[10px] tracking-[0.35em] text-[#C9A869]">DANSE</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <a
              key={l.hash}
              href={buildHref(l.hash)}
              data-testid={`nav-${l.hash.replace("#", "")}`}
              className="text-[12.5px] tracking-[0.18em] uppercase text-[#F7F3EA]/85 hover:text-[#C9A869] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={buildHref("#contact")}
          data-testid="header-cta-reserver"
          className="hidden md:inline-flex items-center gap-2 px-6 py-3 border border-[#C9A869] text-[#C9A869] text-[11px] tracking-[0.25em] uppercase hover:bg-[#C9A869] hover:text-[#0E1A2B] transition-all duration-500"
        >
          Réserver un cours
        </a>

        <button
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden p-2 text-[#C9A869]"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#0E1A2B] border-t border-[#C9A869]/20">
          <nav className="flex flex-col px-6 py-6 gap-4">
            {navLinks.map((l) => (
              <a
                key={l.hash}
                href={buildHref(l.hash)}
                onClick={closeMenu}
                className="text-sm uppercase tracking-[0.2em] text-[#F7F3EA]/90 hover:text-[#C9A869]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={buildHref("#contact")}
              onClick={closeMenu}
              data-testid="mobile-cta-reserver"
              className="mt-3 inline-flex justify-center items-center px-6 py-3 border border-[#C9A869] text-[#C9A869] text-xs tracking-[0.25em] uppercase"
            >
              Réserver un cours
            </a>
          </nav>
        </div>
      )}
    </header>
  );
};
